import { render, staticRenderFns } from "./VConsultar.vue?vue&type=template&id=2de59773&scoped=true&"
import script from "./VConsultar.vue?vue&type=script&lang=js&"
export * from "./VConsultar.vue?vue&type=script&lang=js&"
import style0 from "./VConsultar.vue?vue&type=style&index=0&id=2de59773&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de59773",
  null
  
)

export default component.exports